import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=3a6ae690&"
import script from "./DeliveryView.vue?vue&type=script&lang=ts&"
export * from "./DeliveryView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryView.vue"
export default component.exports